export const SUMARIO_ANUAL = [
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "71328769000181",
    "nomeDeclarante": "SICOOB COCRED COOPERATIVA DE CREDITO",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "3277",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 12,
        "rendimentoTributavel": 11136.3,
        "impostoRetido": 2193.12,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "71328769000181",
    "nomeDeclarante": "SICOOB COCRED COOPERATIVA DE CREDITO",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "8053",
    "nomeTributo": "IRRF",
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 7,
        "rendimentoTributavel": 155670.71,
        "impostoRetido": 0.0,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 83462.6,
        "impostoRetido": 0.02,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 1,
        "rendimentoTributavel": 73.1,
        "impostoRetido": 24.28,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 2,
        "rendimentoTributavel": 113.48,
        "impostoRetido": 26.01,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 4,
        "rendimentoTributavel": 2954.55,
        "impostoRetido": 664.76,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 11091.54,
        "impostoRetido": 2435.19,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 11,
        "rendimentoTributavel": 13606.55,
        "impostoRetido": 2040.96,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 51873.62,
        "impostoRetido": 7781.04,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 11,
        "rendimentoTributavel": 54957.66,
        "impostoRetido": 8243.65,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 73056.63,
        "impostoRetido": 10958.49,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 11,
        "rendimentoTributavel": 10263.42,
        "impostoRetido": 1539.51,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "60746948000112",
    "nomeDeclarante": "OWMKX OIWNHUKX U W",
    "nomeBeneficiario": "WDNX FHNIHUKCQ",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 1,
        "rendimentoTributavel": 457.83,
        "impostoRetido": 193.35,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 1986.15,
        "impostoRetido": 297.91,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 7,
        "rendimentoTributavel": 1793.34,
        "impostoRetido": 532.43,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 8,
        "rendimentoTributavel": 2116.49,
        "impostoRetido": 476.18,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 9,
        "rendimentoTributavel": 371.86,
        "impostoRetido": 83.66,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 615.85,
        "impostoRetido": 138.56,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 11,
        "rendimentoTributavel": 9025.73,
        "impostoRetido": 1672.13,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "60746948000112",
    "nomeDeclarante": "OWMKX OIWNHUKX U W",
    "nomeBeneficiario": "WDNX FHNIHUKCQ",
    "codigoReceita": "8053",
    "nomeTributo": "IRRF",
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 1,
        "rendimentoTributavel": 4.99,
        "impostoRetido": 1.11,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 2,
        "rendimentoTributavel": 13807.58,
        "impostoRetido": 2418.07,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 3,
        "rendimentoTributavel": 15.52,
        "impostoRetido": 3.48,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 4,
        "rendimentoTributavel": 14.66,
        "impostoRetido": 3.29,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 27.74,
        "impostoRetido": 6.19,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 6,
        "rendimentoTributavel": 0.1,
        "impostoRetido": 0.02,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 7,
        "rendimentoTributavel": 28.64,
        "impostoRetido": 6.4,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 8,
        "rendimentoTributavel": 14064.21,
        "impostoRetido": 2109.85,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 9,
        "rendimentoTributavel": 12.05,
        "impostoRetido": 2.69,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 2.71,
        "impostoRetido": 0.6,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 11,
        "rendimentoTributavel": 2.64,
        "impostoRetido": 0.58,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 12,
        "rendimentoTributavel": 5.73,
        "impostoRetido": 1.29,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "51990695000137",
    "nomeDeclarante": "OIWNHUKX EQNW H FIHEQNHMKQW U W",
    "nomeBeneficiario": "WDNX FHNIHUKCQ",
    "codigoReceita": "3579",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 6,
        "rendimentoTributavel": 190014.8,
        "impostoRetido": 47503.63,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 8,
        "rendimentoTributavel": 361877.5,
        "impostoRetido": 90469.35,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "06947853000111",
    "nomeDeclarante": "SAFRA SERVICOS DE ADMINIST. FIDUCIARIA LTDA",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 1,
        "rendimentoTributavel": 1462.92,
        "impostoRetido": 569.3,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 2,
        "rendimentoTributavel": 7872.7,
        "impostoRetido": 2162.58,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2019,
    "tipoNiDeclarante": 2,
    "niDeclarante": "06947853000111",
    "nomeDeclarante": "SAFRA SERVICOS DE ADMINIST. FIDUCIARIA LTDA",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 3,
        "rendimentoTributavel": 1.58,
        "impostoRetido": 0.35,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 4,
        "rendimentoTributavel": 234.29,
        "impostoRetido": 52.68,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 99.75,
        "impostoRetido": 15.3,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 6,
        "rendimentoTributavel": 73.39,
        "impostoRetido": 23.57,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 7,
        "rendimentoTributavel": 1.08,
        "impostoRetido": 0.24,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 8,
        "rendimentoTributavel": 361.97,
        "impostoRetido": 81.36,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 9,
        "rendimentoTributavel": 85.63,
        "impostoRetido": 19.22,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 3.46,
        "impostoRetido": 0.77,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 11,
        "rendimentoTributavel": 88.89,
        "impostoRetido": 16.67,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 12,
        "rendimentoTributavel": 37.42,
        "impostoRetido": 11.62,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "71328769000181",
    "nomeDeclarante": "SICOOB COCRED COOPERATIVA DE CREDITO",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "3277",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 12,
        "rendimentoTributavel": 5104.51,
        "impostoRetido": 534.38,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "71328769000181",
    "nomeDeclarante": "SICOOB COCRED COOPERATIVA DE CREDITO",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "8053",
    "nomeTributo": "IRRF",
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 2,
        "rendimentoTributavel": 13803.26,
        "impostoRetido": 0.0,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 3,
        "rendimentoTributavel": 98885.56,
        "impostoRetido": 0.0,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 124.79,
        "impostoRetido": 24.96,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 1,
        "rendimentoTributavel": 3622.37,
        "impostoRetido": 1488.86,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 3,
        "rendimentoTributavel": 6408.24,
        "impostoRetido": 1441.85,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 6972.71,
        "impostoRetido": 1045.89,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 9,
        "rendimentoTributavel": 9571.07,
        "impostoRetido": 2593.08,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 20601.84,
        "impostoRetido": 3090.26,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 2,
        "rendimentoTributavel": 4927.31,
        "impostoRetido": 739.09,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 39099.89,
        "impostoRetido": 5864.98,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "61809182000130",
    "nomeDeclarante": "CSHG CORRETORA DE VALORES S A",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 5,
        "rendimentoTributavel": 9766.63,
        "impostoRetido": 1464.99,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 10,
        "rendimentoTributavel": 33545.38,
        "impostoRetido": 7197.4,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  },
  {
    "anoCalendario": 2020,
    "tipoNiDeclarante": 2,
    "niDeclarante": "06947853000111",
    "nomeDeclarante": "SAFRA SERVICOS DE ADMINIST. FIDUCIARIA LTDA",
    "nomeBeneficiario": "ALDO PEDRESCHI",
    "codigoReceita": "6800",
    "nomeTributo": null,
    "rendimentoIsentoAnual": 0.0,
    "ocorrencias": [
      {
        "numeroOcorrencia": 1,
        "rendimentoTributavel": 29.24,
        "impostoRetido": 6.55,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 2,
        "rendimentoTributavel": 1.13,
        "impostoRetido": 0.25,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      },
      {
        "numeroOcorrencia": 3,
        "rendimentoTributavel": 146.81,
        "impostoRetido": 33.01,
        "rendimentoIsento": 0.0,
        "deducaoTributavelPrevidenciaOficial": 0.0,
        "deducaoTributavelDependente": 0.0,
        "deducaoTributavelPensaoAlimenticia": 0.0,
        "deducaoTributavelPrevidenciaPrivada": 0.0,
        "qtdMesesRra": 0,
        "despesaAcaoJudicial": 0.0
      }
    ]
  }
];
